const apiRootDev = 'http://localhost';
const apiRootProd = 'https://hub-api.tmxanalytics.com';
export const APP_PORT = process.env.APP_PORT || 3010;

export const apiRoot = (process.env.NODE_ENV === 'development') ? `${apiRootDev}:${APP_PORT}/` : `${apiRootProd}/`;
